export default __webpack_public_path__ + "static/media/img_scsc_11.8ee164cb.png";